module.exports = __webpack_public_path__ + "static/img/5-5.74ebe417.png";